import * as marietta from '../..';
import { Stage } from '../model';

/**
 * ドラッググループ選択のクラス
 */
class ItemControllerDragGroupSelect {
  rect: SVGPathElement;

  dragImage: SVGElement;

  dotList: marietta.core.Point[] = [];

  startPoint: marietta.core.Point;

  endPoint: marietta.core.Point;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  private static _instance = null;

  /**
   * コンストラクタ
   */
  constructor() {
    if (ItemControllerDragGroupSelect._instance) {
      throw new Error('must use the getInstance.');
    }
    //            this.initMe();
  }

  /**
   * シングルトン
   * @param preserveSelection true の場合、開始時点の選択状態をクリアせずに保持する
   */
  static getInstance(preserveSelection: boolean = false): ItemControllerDragGroupSelect {
    if (ItemControllerDragGroupSelect._instance === null) {
      ItemControllerDragGroupSelect._instance = new ItemControllerDragGroupSelect();
    }
    ItemControllerDragGroupSelect._instance.initMe(preserveSelection);
    return ItemControllerDragGroupSelect._instance;
  }

  /**
   * 初期化
   * @param preserveSelection true の場合、開始時点の選択状態をクリアせずに保持する
   */
  initMe(preserveSelection: boolean = false) {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    if (document.getElementById('dragImageSelect')) {
      document.getElementById('dragImageSelect').remove();
    }
    this.startDrag(preserveSelection);
  }

  /**
   * ドラッグ開始
   * @param preserveSelection true の場合、開始時点の選択状態をクリアせずに保持する
   */
  startDrag(preserveSelection: boolean = false) {
    if (!preserveSelection) {
      // カレントをなくす
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
      marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
      marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
    }
    const floor: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    // ドラッグイメージの作成
    this.dragImage = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.dragImage.setAttribute('id', 'dragImageSelect');
    tarLayer.viewObj.appendChild(this.dragImage);

    // 開始地点の座標
    this.startPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.startPoint.x = Math.round(this.startPoint.x / snapUnit) * snapUnit;
    this.startPoint.y = Math.round(this.startPoint.y / snapUnit) * snapUnit;

    // ドラッグエリアの作成
    this.rect = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.rect.setAttribute('fill', '#0026FF');
    this.rect.setAttribute('fill-opacity', '0.3');
    this.rect.setAttribute('stroke', '#0026FF');
    this.rect.setAttribute('stroke-width', '1');
    this.rect.setAttribute('id', 'dragRect');
    this.dragImage.appendChild(this.rect);

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.addEventListener('touchstart', this.onMouseDown);
      document.addEventListener('touchmove', this.moveDrag, { passive: false });
      document.addEventListener('touchend', this.endDrag, { passive: false });
    } else {
      document.addEventListener('mousemove', this.moveDrag);
      document.addEventListener('mouseup', this.endDrag);
    }
    ua = null;
  }

  onMouseDown = (e: MouseEvent&TouchEvent) => {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
      this.startPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      this.startPoint.x = Math.round(this.startPoint.x / snapUnit) * snapUnit;
      this.startPoint.y = Math.round(this.startPoint.y / snapUnit) * snapUnit;
      document.removeEventListener('touchstart', this.onMouseDown);
    }
  }

  /**
   * ドラッグ中の制御
   */

  moveDrag = (e: MouseEvent&TouchEvent) => {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 2本指ジェスチャ（ピンチ・パン）に切り替わった場合は、範囲選択とみなさず中断する。
      // ここで中断しないと、指を離した際のtouchendで無関係な矩形により選択状態が書き換えられてしまう。
      if (e.touches.length >= 2) {
        this.cancelDrag();
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    } else {
      e.preventDefault();
    }
    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
    this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;

    // ドラッグエリアの座標作成
    let pathList = `M ${this.startPoint.x} ${this.startPoint.y} `;
    pathList += `L ${this.startPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.startPoint.y} `;
    pathList += 'Z';
    this.rect.setAttribute('d', pathList);
  }

  /**
   * ドラッグ終了
   */
  endDrag = (e: MouseEvent&TouchEvent) => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if ((ua.isMobile || ua.isTablet) && e.touches && e.touches.length > 0) {
      // まだ他の指が触れている（2本指ジェスチャの片方が離れただけ）ので、
      // 最終的なtouchendではない。ここでは何もせず、全ての指が離れるのを待つ。
      return;
    }
    e.preventDefault();
    if (ua.isMobile || ua.isTablet) {
      //                document.removeEventListener("touchstart", this.startDrag );
      document.removeEventListener('touchmove', this.moveDrag);
      document.removeEventListener('touchend', this.endDrag);
    } else {
      //                document.removeEventListener("mousedown", this.startDrag );
      document.removeEventListener('mousemove', this.moveDrag);
      document.removeEventListener('mouseup', this.endDrag);
    }
    ua = null;
    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
    this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;

    // 開始地点と終了地点が等しいなら何もしない
    if (this.startPoint.x === this.endPoint.x || this.startPoint.y === this.endPoint.y) {
      this.clean();
      return false;
    }

    // 座標の保持
    this.dotList = [
      this.startPoint,
      new marietta.core.Point(this.startPoint.x, this.endPoint.y),
      this.endPoint,
      new marietta.core.Point(this.endPoint.x, this.startPoint.y),
    ];
    // 形状作成終了
    this.endMakeShape();
    return false;
  }

  /**
   * 形状作成の終了
   */
  endMakeShape() {
    // 始点と終点内にあるオブジェクトを全て取得
    const tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.FloorLayer;
    const allItemsOnCurrentLayer = tarLayer.getAllItems();
    const includedItems = [];
    let tarRect: marietta.core.Rectangle;

    const selectionRect: marietta.core.Rectangle = new marietta.core.Rectangle(Math.min(this.startPoint.x, this.endPoint.x),
      Math.min(this.startPoint.y, this.endPoint.y),
      Math.max(this.startPoint.x, this.endPoint.x) - Math.min(this.startPoint.x, this.endPoint.x),
      Math.max(this.startPoint.y, this.endPoint.y) - Math.min(this.startPoint.y, this.endPoint.y));

    for (let i = 0, len = allItemsOnCurrentLayer.length; i < len; i += 1) {

      // 参照モードなら無効
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode !== '2'
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.parts.RoomText)
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.parts.UpStair)
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.GroupItem)
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.parts.GroupItemWall)
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.Site)
          && !(allItemsOnCurrentLayer[i] instanceof marietta.webcad.item.Roof)) {
        tarRect = (allItemsOnCurrentLayer[i] as marietta.webcad.item.MonicaObject).getBoundRect();
        if (selectionRect.containsRect(tarRect)) {
          includedItems.push(allItemsOnCurrentLayer[i]);
        }
      }
    }

    // 選択できたアイテムをグループ化
    if (includedItems.length > 0) {
      marietta.webcad.WebCADGlobal.itemManager.addItems(includedItems);
    }

    // 作成用モジュールなど削除する
    this.clean();
    // 複数選択モードはドラッグ選択後も維持する（続けてタップでトグル選択できるようにするため）。
    // モードOFFは「複数選択」ボタンの再タップで行う（btnHeaderGroupSelectModeClickEventHandler）。
  }

  /**
   * 作成用モジュールなど削除する
   */
  clean() {
    if (this.dragImage) {
      this.dragImage.remove();
    }
    this.dragImage = null;
  }

  /**
   * 範囲選択の中断
   * 2本指ジェスチャ（ピンチ・パン）に切り替わった場合など、範囲選択を確定させずに終了する。
   * endMakeShape()を呼ばないため、選択状態（currentItemGroup等）は変更しない。
   */
  cancelDrag() {
    document.removeEventListener('touchmove', this.moveDrag);
    document.removeEventListener('touchend', this.endDrag);
    document.removeEventListener('touchstart', this.onMouseDown);
    this.clean();
  }

  /**
   * 選択したGroupItemを整列します
   * @param align type= string; values = "top", "bottom", "right", "left", "verticalCenter", "horizontalCenter" etc
   * @return void
  * */
  static align(align:string = '') {
    if (align === '') return;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup === null) return;
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    const groupRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getGroupRectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value) => {
      rect.x = value.itemInfo.x;
      rect.y = value.itemInfo.y;
      rect.width = value.itemInfo.width;
      rect.height = value.itemInfo.height;
      let boundRect:marietta.core.Rectangle = new marietta.core.Rectangle();
      boundRect = ItemControllerDragGroupSelect.getBoundingClientRect(value);
      const alignPos:marietta.core.Point = ItemControllerDragGroupSelect.getAlignPos(rect, boundRect, groupRect, align);

      const _value = value;
      _value.itemInfo.x = alignPos.x;
      _value.itemInfo.y = alignPos.y;
      value.updateTransforms();
    });
    // 履歴に載せる前に呼ぶ
    marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.createImage();
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 等間隔の配置
   * @param align type= string; values = "horizontal", "vertical" etc
   * @return void
  * */
  static equalAlign(align:string = '') {
    if (align === '') return;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup === null) return;
    const xy:string = (align === 'horizontal') ? 'x' : 'y';
    const wh:string = (align === 'horizontal') ? 'width' : 'height';
    const groupRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getGroupRectangle();
    const sumRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getSumRect();
    const gap:number = (groupRect[wh] - sumRect[wh]) / (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.length - 1);
    if (gap < 0) {
      // gap = 0;
    }
    const myItemList:marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.concat();
    myItemList.sort((a:marietta.webcad.item.MonicaObject, b:marietta.webcad.item.MonicaObject) => {
      const boundRectA:marietta.core.Rectangle = ItemControllerDragGroupSelect.getBoundingClientRect(a);
      const boundRectB:marietta.core.Rectangle = ItemControllerDragGroupSelect.getBoundingClientRect(b);
      if (boundRectA[xy] < boundRectB[xy]) return -1;
      if (boundRectA[xy] > boundRectB[xy]) return 1;
      return 0;
    });

    let nextPos:number = 0;
    myItemList.forEach((value:marietta.webcad.item.MonicaObject) => {
      const boundRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getBoundingClientRect(value);
      const _value = value;
      _value.itemInfo[xy] = groupRect[xy] + nextPos + (value.itemInfo[xy] - boundRect[xy]);
      value.updateTransforms();
      nextPos += boundRect[wh] + gap;
    });
    // 履歴に載せる前に呼ぶ
    marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.createImage();
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 選択されている全てのアイテムの横幅縦幅の合計を取得する
   * @return marietta.core.Rectangle
  * */
  static getSumRect() {
    const sum:marietta.core.Rectangle = new marietta.core.Rectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value) => {
      const boundRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getBoundingClientRect(value);
      sum.width += boundRect.width;
      sum.height += boundRect.height;
    });
    return sum;
  }

  /**
   * グループアイテムのRectを取得する
   * @return marietta.core.Rectangle
  * */
  static getGroupRectangle() {
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value:marietta.webcad.item.MonicaObject, index:number) => {
      const boundRect:marietta.core.Rectangle = ItemControllerDragGroupSelect.getBoundingClientRect(value);
      if (index === 0) {
        rect.x = boundRect.x;
        rect.y = boundRect.y;
        rect.width = boundRect.x + boundRect.width;
        rect.height = boundRect.y + boundRect.height;
        return;
      }

      if (boundRect.x < rect.x) {
        rect.x = boundRect.x;
      }
      if (boundRect.y < rect.y) {
        rect.y = boundRect.y;
      }
      if (rect.width < (boundRect.x + boundRect.width)) {
        rect.width = boundRect.x + boundRect.width;
      }
      if (rect.height < (boundRect.y + boundRect.height)) {
        rect.height = boundRect.y + boundRect.height;
      }
    });
    rect.width -= rect.x;
    rect.height -= rect.y;
    return rect;
  }

  /**
   * 整列座標の取得
   * @param rect type = Rectangle; 各グループ項目の位置とサイズのデータ（単一項目）
   * @param boundRect type = Group; 各アイテムgetBoundingClientRectデータ
   * @param groupRect type = Rectangle; getGroupRectangle関数からグループデータを取得する
   * @param align  type = string; グループアイテムの配置タイプ
   * @return marietta.core.Point
   *
  * */
  static getAlignPos(rect:marietta.core.Rectangle, boundRect:marietta.core.Rectangle, groupRect:marietta.core.Rectangle, align:string) {
    const alignPos:marietta.core.Point = new marietta.core.Point(undefined, undefined);
    switch (align) {
      case 'left':
        alignPos.x = groupRect.x + (rect.x - boundRect.x);
        alignPos.y = rect.y;
        break;
      case 'right':
        alignPos.x = groupRect.x + groupRect.width + (rect.x - boundRect.x) - boundRect.width;
        alignPos.y = rect.y;
        break;
      case 'top':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + (rect.y - boundRect.y);
        break;
      case 'bottom':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + groupRect.height + (rect.y - boundRect.y) - boundRect.height;
        break;
      case 'horizontalCenter':
        alignPos.x = groupRect.x + (groupRect.width / 2) + (rect.x - boundRect.x) - boundRect.width / 2;
        alignPos.y = rect.y;
        break;
      case 'verticalCenter':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + (groupRect.height / 2) + (rect.y - boundRect.y) - boundRect.height / 2;
        break;
      default: break;
    }
    return alignPos;
  }

  /**
   * Monicaobject境界位置データを取得します
   * @param object MonicaObject
   * @return marietta.core.Rectangle
  * */
  static getBoundingClientRect(object:marietta.webcad.item.MonicaObject) {
    const clientRect = object.getBoundingClientRect();
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    rect.x = clientRect.left / marietta.webcad.WebCADGlobal.scaleSize;
    rect.y = clientRect.top / marietta.webcad.WebCADGlobal.scaleSize;
    rect.width = clientRect.width / marietta.webcad.WebCADGlobal.scaleSize;
    rect.height = clientRect.height / marietta.webcad.WebCADGlobal.scaleSize;
    return rect;
  }
}
export default ItemControllerDragGroupSelect;
